import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { ContentfulContext } from '../../Context/Contentful';

const StyledHeaderLogo = styled.div`
	.logo {
		&.vir {
			height: 60px;
		}

		&.adc {
			height: 48px;
		}
	}
`;

function HeaderLogo({ brandData }) {
	const {
		entries: {
			items: [
				{
					fields: { partnerLogoLink },
				},
			],
		},
	} = useContext(ContentfulContext);
	const { logo, name, tag } = brandData;

	return (
		<StyledHeaderLogo>
			<div className='header__logo'>
				<img
					src={logo}
					alt={name + ' Logo'}
					title={name}
					className={'d-inline-block logo ' + tag}
				/>

				{partnerLogoLink && (
					<img
						src={partnerLogoLink}
						alt={name + ' Logo'}
						title={name}
						className={'d-none d-sm-inline-block logo mh-100 ml-30 ' + tag}
					/>
				)}
			</div>
		</StyledHeaderLogo>
	);
}

export default HeaderLogo;
